<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-sub-title class="mb-25">
          Statistik
        </b-card-sub-title>
        <b-card-title class="font-weight-bolder">
          Konsultasi berdasarkan Unit Pelaksana Teknis
        </b-card-title>
      </div>
      <!--/ title and subtitle -->

      <!-- datepicker -->
      <!-- <div class="d-flex align-items-center">
            <feather-icon
              icon="CalendarIcon"
              size="16"
            />
            <flat-pickr
              v-model="rangePicker"
              :config="{ mode: 'range'}"
              class="form-control flat-picker bg-transparent border-0 shadow-none"
              placeholder="YYYY-MM-DD"
            />
          </div> -->
      <!-- datepicker -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="bar"
        height="350"
        :options="barChart.chartOptions"
        :series="barChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardSubTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    // BRow,
    // BCol,
    BCard,
    BCardHeader,
    BCardSubTitle,
    BCardTitle,
    // BCardText,
    BCardBody,
    // BMedia,
    // BAvatar,
    // BMediaAside,
    // BMediaBody,
    VueApexCharts,
    // flatPickr,
  },
  props: {
    barChart: {},
    rangePicker: {},
    apexChatData: {},
  },
}
</script>
